// Bundles
export const BUNDLE_INDEX_REQUEST: string = "Upload/Bundles/INDEX_REQUEST";
export const BUNDLE_INDEX_SUCCESS: string = "Upload/Bundles/INDEX_SUCCESS";
export const BUNDLE_INDEX_FAILURE: string = "Upload/Bundles/INDEX_FAILURE";

export const BUNDLE_STORE_REQUEST: string = "Upload/Bundles/STORE_REQUEST";
export const BUNDLE_STORE_SUCCESS: string = "Upload/Bundles/STORE_SUCCESS";
export const BUNDLE_STORE_FAILURE: string = "Upload/Bundles/STORE_FAILURE";

export const BUNDLE_SHOW_REQUEST: string = "Upload/Bundles/SHOW_REQUEST";
export const BUNDLE_SHOW_SUCCESS: string = "Upload/Bundles/SHOW_SUCCESS";
export const BUNDLE_SHOW_FAILURE: string = "Upload/Bundles/SHOW_FAILURE";

export const BUNDLE_UPDATE_REQUEST: string = "Upload/Bundles/UPDATE_REQUEST";
export const BUNDLE_UPDATE_SUCCESS: string = "Upload/Bundles/UPDATE_SUCCESS";
export const BUNDLE_UPDATE_FAILURE: string = "Upload/Bundles/UPDATE_FAILURE";

export const BUNDLE_STORE_ALBUM_REQUEST: string = "Upload/Bundles/STORE_ALBUM_REQUEST";
export const BUNDLE_STORE_ALBUM_SUCCESS: string = "Upload/Bundles/STORE_ALBUM_SUCCESS";
export const BUNDLE_STORE_ALBUM_FAILURE: string = "Upload/Bundles/STORE_ALBUM_FAILURE";

export const BUNDLE_UPLOAD_ZIP_REQUEST: string = "Upload/Bundles/UPLOAD_ZIP_REQUEST";
export const BUNDLE_UPLOAD_ZIP_SUCCESS: string = "Upload/Bundles/UPLOAD_ZIP_SUCCESS";
export const BUNDLE_UPLOAD_ZIP_FAILURE: string = "Upload/Bundles/UPLOAD_ZIP_FAILURE";

export const BUNDLE_COMPLETE_REQUEST: string = "Upload/Bundles/COMPLETE_REQUEST";
export const BUNDLE_COMPLETE_SUCCESS: string = "Upload/Bundles/COMPLETE_SUCCESS";
export const BUNDLE_COMPLETE_FAILURE: string = "Upload/Bundles/COMPLETE_FAILURE";
